module.exports = __webpack_public_path__ + "img/logo.895e2a34.png";